<template>
  <vx-card class="insert-bank-page top-zero-radius" :class="{'w-full': inModal, ' main-box md:w-1/2 p-2': !inModal}">
    <custom-validate-input class="w-full"
                           :label="`${$t('treasury.banks.labels.name')}`"
                           :invalid-text="validation.name"
                           :autocomplete="false"
                           align="right"
                           rtl
                           :name="Math.random()"
                           v-model="new_bank.name"/>

    <custom-number-input class="w-full"
                         :label="`${$t('treasury.banks.labels.accountNumber')}`"
                         :invalid-text="validation.account_number"
                         is-empty
                         :autocomplete="false"
                         :name="Math.random()"
                         :regex="$u.validator('regex.treasury.bank.accountNumber')"
                         v-model="new_bank.account_number"/>

    <custom-card-number-input class="w-full"
                              :label="`${$t('treasury.banks.labels.cardNumber')}`"
                              :invalid-text="validation.card_number"
                              is-empty
                              :autocomplete="false"
                              :name="Math.random()"
                              v-model="new_bank.card_number"/>

    <custom-number-input class="w-full"
                         :label="`${$t('treasury.banks.labels.shebaNumber')}`"
                         :invalid-text="validation.shaba_number"
                         is-empty
                         :autocomplete="false"
                         :name="Math.random()"
                         v-model="new_bank.shaba_number"/>

    <vs-button id="insertBankBTN"
               class="useral-action-button"
               @click="sendData()"/>
  </vx-card>
</template>

<script>
import axios from 'axios'
import {insertBank} from '@/http/requests/banks'
import CustomValidateInput from "../../../../../components/customInput/customValidateInput.vue";
import CustomNumberInput from "../../../../../components/customInput/customNumberInput.vue";
import CustomCardNumberInput from "../../../../../components/customInput/customCardNumberInput.vue";

export default {
  name: 'insertBank',
  components: {CustomCardNumberInput, CustomNumberInput, CustomValidateInput},
  metaInfo () {
    return {
      title: this.$t('treasury.banks.insert.title')
    }
  },
  props: {
    inModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      new_bank: {
        name: {
          value: '',
          isValid: true
        },
        account_number: {
          value: '',
          isValid: true
        },
        card_number: {
          value: '',
          isValid: true
        },
        shaba_number: {
          value: '',
          isValid: true
        }
      },
      validation: {
        name: '',
        account_number: '',
        card_number: '',
        shaba_number: ''
      },
      actions: [
        {
          toolbar: [
            {
              id: 'insertBankBTN',
              icon: 'icon-check',
              iconPack: 'feather',
              color: 'success',
              permission: 'bank.create'
            }
          ],
          leftToolbar: [
            {
              id: 'routeBackBTN',
              route: {name: 'treasuryBanks'},
              icon: 'chevron-left-icon',
              iconPack: 'useral'
            }
          ]
        }
      ]
    }
  },
  created () {
    this.$nextTick(() => {
      if (!this.inModal) {
        this.$store.dispatch('updateNavbarActions', this.actions[0])
        this.$store.dispatch('updateContentNavbarStyle', 'sticky')
        this.$store.dispatch('updateContentNavbarClass', 'md:w-1/2 mx-auto')
      }
    })
  },
  methods: {
    addDash (val) {
      let sign = ''

      if (val < 0) sign = '-'

      val = val.toString()

      if (val[0] === '0') val = val.substr(1, val.length - 1)

      return val.toString().replace(/\D/g, '')
        .replace(/\B(?=(\d{4})+(?!\d))/g, '-') + sign
    },
    isNumber (val) {
      return val.toString().replace(/[^0-9]/g, '')
    },
    sendData () {
      this.nameValidator(this.new_bank.name)

      if (!this.validation.name &&
        !this.validation.account_number &&
        !this.validation.card_number &&
        !this.validation.shaba_number &&
        !(this.new_bank.card_number.value === '' &&
          this.new_bank.account_number.value === '' &&
          this.new_bank.shaba_number.value === '')) {

        const payload = {
          name: this.new_bank.name.value
        }
        if (this.new_bank.account_number.value) payload.account_number = this.new_bank.account_number.value
        if (this.new_bank.card_number.value) payload.card_number = this.new_bank.card_number.value
        if (this.new_bank.shaba_number.value) payload.shaba_number = this.new_bank.shaba_number.value

        insertBank(payload).then((response) => {
          this.$vs.notify({
            title: this.$t('alert.message.title'),
            text: this.$t('treasury.banks.insert.notifications.insert.success'),
            time: 2400,
            icon: 'icon-check',
            iconPack: 'feather',
            color: 'success'
          })

          this.$store.dispatch('removePageChanges')

          if (!this.inModal) {
            this.$router.push({name: 'treasuryBanks'})
          } else {
            this.$emit('inserted', response.data.data)
          }

        }).catch(error => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          } else {
            this.$vs.notify({
              title: this.$t('alert.error.title'),
              text: this.$t('treasury.banks.insert.notifications.insert.error'),
              time: 2400,
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              color: 'danger'
            })
          }
        })
      } else {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('treasury.banks.insert.notifications.insert.error'),
          time: 2400,
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          color: 'danger'
        })
      }
    },
    nameValidator (value) {
      this.validation.name = value.toString().length >= 2 ? '' : this.$t('treasury.banks.validators.name')
    },
    accountNumberValidator (value) {
      if (this.$u.validator('regex.treasury.bank.accountNumber').test(value) || value === '') {
        this.validation.account_number = ''
        if (this.new_bank.card_number.value === '') {
          this.validation.card_number = ''
        }
        if (this.new_bank.shaba_number.value === '') {
          this.validation.shaba_number = ''
        }
      } else {
        this.validation.account_number = this.$t('treasury.banks.validators.accountNumber')
      }
    },
    cardNumberValidator (value) {
      const card = value.toString().replaceAll('-', '')
      if ((typeof card === 'undefined'
        || card === null
        || card.length !== 16)
        && card !== '') {
        this.validation.card_number = this.$t('treasury.banks.validators.cardNumber')
      } else {
        this.validation.card_number = ''
        if (this.new_bank.account_number.value === '') {
          this.validation.account_number = ''
        }
        if (this.new_bank.shaba_number.value === '') {
          this.validation.shaba_number = ''
        }
      }
    },
    shabaNumberValidator (value) {
      if (this.$u.validator('regex.treasury.bank.shabaNumber').test(value) || value === '') {
        this.validation.shaba_number = ''
        if (this.new_bank.account_number.value === '') {
          this.validation.account_number = ''
        }
        if (this.new_bank.card_number.value === '') {
          this.validation.card_number = ''
        }
      } else {
        this.validation.shaba_number = this.$t('treasury.banks.validators.shebaNumber')
      }
    }
  },
  watch: {
    'new_bank': {
      handler () {
        // this.$store.dispatch('setPageChanges')
      },
      deep: true
    },
    'new_bank.name.value': {
      handler (val) {
        this.nameValidator(val)
      }
    },
    'new_bank.account_number.value': {
      handler (val) {
        this.accountNumberValidator(val)
      }
    },
    'new_bank.card_number.value': {
      handler (val) {
        this.cardNumberValidator(val)

        // this.new_bank.card_number = this.addDash(this.new_bank.card_number)
        if (this.new_bank.card_number.value.length > 16) {
          this.new_bank.card_number.value = this.new_bank.card_number.value.toString().substr(0, 16)
        }
      }
    },
    'new_bank.shaba_number.value': {
      handler (val) {
        this.shabaNumberValidator(val)

        if (this.new_bank.shaba_number.value.length > 24) {
          this.new_bank.shaba_number.value = this.new_bank.shaba_number.value.toString().substr(0, 24)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.insert-bank-page {

  .dir-rtl {

    input {
      direction: rtl;
    }
  }
}
</style>
